import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../barcodeform.css';
// eslint-disable-next-line no-unused-vars
import { getApiBaseUrl } from '../../utils/utils'; 
export default function UpdateManualAWB() {

    const API_URL = process.env.REACT_APP_API_URL;
   
    // eslint-disable-next-line no-unused-vars
    const [shipmentDetails, setShipmentDetails] = useState([]);


    const [modalClosed, setModalClosed] = useState(false);

    useEffect(() => {
        if (modalClosed) {
            getDetails();
            setModalClosed(false); // reset
        }
    }, [modalClosed]);

    useEffect(() => {
        const handleModalClose = () => setModalClosed(true);
        window.addEventListener("modalClosed", handleModalClose);

        return () => {
            window.removeEventListener("modalClosed", handleModalClose);
        };
    }, []);

    useEffect(() => {





    }, []);

    const buttonsyle = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        marginRight: '10px',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%'
    }
    const buttonsyle1 = {
        background: '#00a6ed',
        color: '#fff',
        padding: '3px',
        // marginLeft: '75%',
        borderColor: '#00a6ed',
        cursor: 'pointer',
        marginTop: '3%',
        marginBottom: '10%'
    }


    const [msg, setMsg] = useState('')
    const [errormsg, setError] = useState('')
const [formdisp, setformdisp] = useState(false)
    useEffect(() => {
        // Fetch drivers from the API on component mount
        fetchDrivers();
        getUserList();

    }, []);



    const [drivers, setDrivers] = useState()
    const [awb, setAwb] = useState();
    const fetchDrivers = async () => {
        try {
            // Replace this API endpoint with the actual one that fetches drivers based on the emirate
            const response = await axios.get(`${API_URL}shypvdriverapp/driver/getAllDrivers`);

            if (response.data.success) {
                const driversData = response.data.data;  // The array of driver objects

                // Map the response to extract driverId and name
                const driversList = driversData.map(driver => ({
                    driver_id: driver.driverId,
                    driver_name: driver.name
                }));

                // Set the drivers state
                setDrivers(driversList);
            } else {
                console.error('Error fetching drivers for emirate:');
            }
        } catch (error) {
            console.error('Error fetching drivers:', error);
        }
    };

    const [users, setusers] = useState()
    const getUserList = async () => {
        const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

        // Send a GET request to the new API
        try {
            const res = await axios.get(API_PATH);

            console.log(res.data);  // Log the response to inspect it

            // Check if the response contains 'data' and if it's an array
            if (res.data && res.data.success && Array.isArray(res.data.data)) {
                setusers(res.data.data);  // Update the personnel list in the state
            } else {
                console.log('No personnel data found in the response or response is not successful');
            }



        } catch (err) {
            console.log('Error fetching personnel list:', err);

        }
    };

    console.log('drivers:', drivers)

    console.log('users:', users)
    
    function getDetails() {
        console.log('awb is', awb)

        const scannedBarcode = awb
            .split(/[\n,]+/)
            .filter((value) => value.trim() !== '')
            .map((value) => {
                if (value.startsWith('E') && value.charAt(value.length - 5) === 'D') {
                    return value.slice(3, -5);
                }
                return value;
            })[0]; // Get the first element from the array

        let barcodeToUse = scannedBarcode;
        if (!barcodeToUse) {
            barcodeToUse = awb;
        }



        const payload = {

            awbNo: barcodeToUse
        };

        console.log(payload)
        setError('')
        axios.post(`${API_URL}shypvdriverapp/jobs/getJobDetails`, payload)
            .then(response => {
                console.log("Response:", response.data);
                if (response.data.success) {
                    if (response.data.data.length > 0) {
                        setShipmentDetails(response.data.data)
                    } else {
                        setShipmentDetails(response.data.data)

                        setError('booking details not found')
                    }

                } else {

                    setShipmentDetails([])
                    setError('booking details not found')
                }
            })
            .catch(error => {
                console.error("Error:", error);
            });
    }




 

    const [partners, setPartners] = useState([]);
    useEffect(() => {
        const fetchPartners = async () => {

            const baseApiUrl = getApiBaseUrl();
            try {
                const response = await axios.get(`${baseApiUrl}/v1.0/partner/retrieve_list?page=0`);
                setPartners(
                    (response.data.data || [])
                );

            } catch (err) {
                setError(err.message || 'Error fetching data');
            } finally {
                // setLoading(false);
            }
        };

        fetchPartners();
    }, []);




    const [selectedPartner, setSelectedPartner] = useState('0');

    const handleSelectChange = (e) => {
        const partnerId = e.target.value;

        setSelectedPartner(partnerId);


    };





    console.log('shipmentDetails', shipmentDetails)


    const [searchQuery, setSearchQuery] = useState("");

    const filteredDrivers = Array.isArray(drivers)
        ? drivers.filter(driver =>
            driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
        )
        : [];

    const driverOptions = filteredDrivers.map(driver => ({
        value: driver.driver_id,
        label: `${driver.driver_id} - ${driver.driver_name}`
    }));


  const [orderdetails, setOrderdetails] = useState({
  partnerId: selectedPartner,
  partnerCity: "Dubai",
  OpsReference: awb,
  recvrName: "",
  delvAdd: "",
  delvAddAptdtls: "",
  rcvrEmail: "",
  rcvrMobno: "",
  itemDesc: "",
  bookingDate: "",
  amntToBeRcvd: "",
  serviceType: "Timexpress Next day Service",
  noitems: "",
  Dcity: "",
  slot: "1",
  kg: "",
  ln: "",
  hiegt: "",
  wdth: "",
  pkpAdd: "",
  pkpPhone: "",
  pkpName: "",
  pkpEmail: "",
  pkpAddDtl: "",
  pkpCity: "Dubai"
});


 const handleChange = (e) => {
  const { name, value } = e.target;
  setOrderdetails(prev => ({
    ...prev,
    [name]: value
  }));
};


const updateManual = async () => {
  setMsg('')
  setError('')

  const requiredFields = [
    'partnerCity',
    'recvrName',
    'delvAdd',
    'delvAddAptdtls',
    'rcvrEmail',
    'rcvrMobno',
    'itemDesc',
    'bookingDate',
    'amntToBeRcvd',
    'serviceType',
    'noitems',
    'Dcity',
    'slot',
    'kg',
    'ln',
    'hiegt',
    'wdth',
    'pkpAdd',
    'pkpPhone',
    'pkpName',
    'pkpEmail',
    'pkpAddDtl',
    'pkpCity',
  ];

  // Check if all required fields have a value
  const missingFields = requiredFields.filter(field => !orderdetails[field]);

  if (missingFields.length > 0) {
    setError(`Please fill all the required fields`);
    return; // Exit the function if there are missing fields
  }


  const payload = {
    partnerId: selectedPartner,
    partnerCity: orderdetails.partnerCity,
    genOrders: [
      {
        OpsReference: awb,
        recvrName: orderdetails.recvrName,
        delvAdd: orderdetails.delvAdd,
        delvAddAptdtls: orderdetails.delvAddAptdtls,
        rcvrEmail: orderdetails.rcvrEmail,
        rcvrMobno: orderdetails.rcvrMobno,
        itemDesc: orderdetails.itemDesc,
        bookingDate: orderdetails.bookingDate,
        amntToBeRcvd: orderdetails.amntToBeRcvd,
        serviceType: orderdetails.serviceType,
        noitems: parseInt(orderdetails.noitems),
        Dcity: orderdetails.Dcity,
        slot: parseInt(orderdetails.slot),
        kg: parseFloat(orderdetails.kg),
        ln: parseFloat(orderdetails.ln),
        hiegt: parseFloat(orderdetails.hiegt),
        wdth: parseFloat(orderdetails.wdth),
      },
    ],
    pkpGenOrders: [
      {
        pkpAdd: orderdetails.pkpAdd,
        pkpPhone: orderdetails.pkpPhone,
        pkpName: orderdetails.pkpName,
        pkpEmail: orderdetails.pkpEmail,
        pkpAddDtl: orderdetails.pkpAddDtl,
        pkpCity: orderdetails.pkpCity,
      },
    ],
  };

  try {
    const response = await axios.post(
      `${API_URL}shypvdriverapp/OnDemandawb/createEmptyOrder/${awb}`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Order created successfully", response.data);
    if(response.data.success){

      setMsg(`Order updated Successfully, AWB:${response.data.data.bkref}`)
    }
    else{
      setError(response.data.message)
    }
  } catch (error) {
    console.error("Error creating order:", error.response?.data || error.message);
  }
};


function displayform(){
  if(awb && selectedPartner >0){
    setError('')
setformdisp(true)
  }else{
    setError('please pass valid inputs')
  }
 
}

    return (
        <div>
            <div className="form-container">

                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label htmlFor="driver">AWB (Reference)*: </label>
                            <input
                                type="text"
                                value={awb}
                                onChange={e => setAwb(e.target.value)}
                                placeholder="Enter AWB"
                                autoFocus
                            />
                        </div>

                         <div className="form-group">
                                    <label htmlFor="formGroupExampleInput2" className="m-form">Partner*</label>
                                    <select onChange={handleSelectChange} value={selectedPartner} style={{ marginRight: '10px' }}>
                                        <option value="" disabled>
                                            -- Select a partner --
                                        </option>
                                        <option value="0">All</option>
                                        {partners && [...partners].sort((a, b) => a.pname.localeCompare(b.pname)).map((partner) => (
                                            <option key={partner.pid} value={partner.pid}>
                                               {partner.pid}- {partner.pname}
                                            </option>
                                        ))}
                                    </select>

                                </div>


                        <a onClick={displayform} style={buttonsyle} type="button" className="btn-demo add">
                            Submit
                        </a>
                        <p style={{ color: 'red', marginTop: '2%' }}>{errormsg}</p>
                    </div>







                </div>
             {formdisp && (
              <>
 <div className="row ">
                    <div className="col-md-1"></div>
                    <div className="col-md-9">

                        {/* <div className="container mt-3"> */}
                        <h4>Shipment Details - {awb}</h4>
         <form>
  <div className="row" style={{ background: '#06003c1c' }}>

    {/* Shipper Details */}
    <div className="col-md-4 mb-4" style={{ borderRight: '1px solid' }}>
      <div className="p-3 border rounded">
        <h5>Shipper Details</h5>
        <div className="form-group mb-2">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            name="pkpName"
            value={orderdetails.pkpName}
            onChange={handleChange}
            placeholder="Shipper Name"
          />
        </div>
        <div className="form-group mb-2">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            name="pkpEmail"
            value={orderdetails.pkpEmail}
            onChange={handleChange}
            placeholder="Shipper Email"
          />
        </div>
        <div className="form-group mb-2">
          <label>Address</label>
          <input
            type="text"
            className="form-control"
            name="pkpAdd"
            value={orderdetails.pkpAdd}
            onChange={handleChange}
            placeholder="Shipper Address"
          />
        </div>
        <div className="form-group mb-2">
          <label>Address Details</label>
          <input
            type="text"
            className="form-control"
            name="pkpAddDtl"
            value={orderdetails.pkpAddDtl}
            onChange={handleChange}
            placeholder="Gate / Landmark / etc."
          />
        </div>
        <div className="form-group mb-2">
          <label>City</label>
          <input
            type="text"
            className="form-control"
            name="pkpCity"
            value={orderdetails.pkpCity}
            onChange={handleChange}
            placeholder="Shipper City"
          />
        </div>
        <div className="form-group mb-2">
          <label>Phone</label>
          <input
            type="text"
            className="form-control"
            name="pkpPhone"
            value={orderdetails.pkpPhone}
            onChange={handleChange}
            placeholder="Shipper Phone"
          />
        </div>
      </div>
    </div>

    {/* Consignee Details */}
    <div className="col-md-4 mb-4" style={{ borderRight: '1px solid' }}>
      <div className="p-3 border rounded">
        <h5>Consignee Details</h5>
       
        <div className="form-group mb-2">
          <label>Name</label>
          <input
            type="text"
            className="form-control"
            name="recvrName"
            value={orderdetails.recvrName}
            onChange={handleChange}
            placeholder="Consignee Name"
          />
        </div>
        <div className="form-group mb-2">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            name="rcvrEmail"
            value={orderdetails.rcvrEmail}
            onChange={handleChange}
            placeholder="Consignee Email"
          />
        </div>
        <div className="form-group mb-2">
          <label>Address</label>
          <input
            type="text"
            className="form-control"
            name="delvAdd"
            value={orderdetails.delvAdd}
            onChange={handleChange}
            placeholder="Consignee Address"
          />
        </div>
        <div className="form-group mb-2">
          <label>Apartment / Floor Details</label>
          <input
            type="text"
            className="form-control"
            name="delvAddAptdtls"
            value={orderdetails.delvAddAptdtls}
            onChange={handleChange}
            placeholder="Apt / Floor / etc."
          />
        </div>
        <div className="form-group mb-2">
          <label>City</label>
          <input
            type="text"
            className="form-control"
            name="Dcity"
            value={orderdetails.Dcity}
            onChange={handleChange}
            placeholder="Consignee City"
          />
        </div>
        <div className="form-group mb-2">
          <label>Phone</label>
          <input
            type="text"
            className="form-control"
            name="rcvrMobno"
            value={orderdetails.rcvrMobno}
            onChange={handleChange}
            placeholder="Consignee Phone"
          />
        </div>
        <div className="form-group mb-2">
          <label>Item Description</label>
          <input
            type="text"
            className="form-control"
            name="itemDesc"
            value={orderdetails.itemDesc}
            onChange={handleChange}
            placeholder="What is being shipped?"
          />
        </div>
      </div>
    </div>

    {/* Package + Booking Info */}
    <div className="col-md-4 mb-4">
      <div className="p-3 border rounded">
        <h5>Booking & Package Details</h5>
         <div className="form-group mb-2">
          <label>Operation Reference</label>
          <input
            type="text"
            className="form-control"
            name="OpsReference"
            value={awb}
            disabled
            // onChange={handleChange}
            placeholder="Ops Ref No"
          />
        </div>

        <div className="form-group mb-2">
          <label>Booking Date & Time</label>
          <input
            type="datetime-local"
            className="form-control"
            name="bookingDate"
            value={orderdetails.bookingDate}
            onChange={handleChange}
          />
        </div>

        <div className="form-group mb-2">
          <label>Payment Type</label>
          <select
            className="form-control"
            name="paymentType"
            value={orderdetails.paymentType}
            onChange={handleChange}
          >
            <option value="prepaid">Prepaid</option>
            <option value="cod">COD</option>
          </select>
        </div>

        <div className="form-group mb-2">
          <label>COD Amount</label>
          <input
            type="number"
            className="form-control"
            name="amntToBeRcvd"
            value={orderdetails.amntToBeRcvd}
            onChange={handleChange}
            placeholder="COD Amount"
          />
        </div>

        <div className="form-group mb-2">
          <label>No. of Pieces</label>
          <input
            type="number"
            className="form-control"
            name="noitems"
            value={orderdetails.noitems}
            onChange={handleChange}
            placeholder="Pcs"
          />
        </div>

        <div className="form-row">
          <div className="form-group col-md-3">
            <label>Weight (kg)</label>
            <input
              type="number"
              className="form-control"
              name="kg"
              value={orderdetails.kg}
              onChange={handleChange}
              placeholder="Weight"
            />
          </div>
          <div className="form-group col-md-3">
            <label>Length (cm)</label>
            <input
              type="number"
              className="form-control"
              name="ln"
              value={orderdetails.ln}
              onChange={handleChange}
              placeholder="L"
            />
          </div>
          <div className="form-group col-md-3">
            <label>Width (cm)</label>
            <input
              type="number"
              className="form-control"
              name="wdth"
              value={orderdetails.wdth}
              onChange={handleChange}
              placeholder="W"
            />
          </div>
          <div className="form-group col-md-3">
            <label>Height (cm)</label>
            <input
              type="number"
              className="form-control"
              name="hiegt"
              value={orderdetails.hiegt}
              onChange={handleChange}
              placeholder="H"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</form>


                    </div>


                    {/* </div> */}

                    {/* <div className="col-md-10">
                        {loading && <p>Loading shipment details...</p>}

                       

                    </div> */}

                </div>

                 <div className="row">
                    
                    <div className="col-md-12" style={{alignItems:'center'}}>

                          <a onClick={updateManual} style={buttonsyle} type="button" className="btn-demo add">
                            Submit
                        </a>
                         <p>{msg}</p>
                         <p style={{color:'red'}}>{errormsg}</p>
                    </div>
                   
                </div>

                </>
             )}  
               

               
            </div>




        </div>
    );
};

